import {React, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux' 
import styled from 'styled-components' 
import { getCoordinates, resetMap, setLocationCoordinates } from 'features/maps/mapSlice' 
import { createEvent, hideEventModal, removeEventImage, updateEvent } from '../../features/events/eventSlice'
import "react-datepicker/dist/react-datepicker.css"; 
import EventNoteIcon from '@mui/icons-material/EventNote';
import { imgUrl } from 'features/constants'
import placeholder from "../../images/directoryImages/default/addImage.png"
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DateRangeIcon from '@mui/icons-material/DateRange'; 
import ModalCloseButton from 'components/buttons/ModalCloseButton'

import SpinnerSmall from 'components/SpinnerSmall'
import useGetWindowSize from 'hooks/useGetWindowSize'
import dayjs from 'dayjs';
import { calendarDate, normalizeEvent } from 'utils/eventContract'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'; 
import MoreTimeIcon from '@mui/icons-material/MoreTime'; 
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { ButttonWrap } from 'components/files/files.styled'
import { SubmitButton } from 'components/giving/giving.styled'  
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import TitleRoundedIcon from '@mui/icons-material/TitleRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import NotesRoundedIcon from '@mui/icons-material/NotesRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import toast  from 'react-hot-toast';
import { pBtn, pBtnSmall } from 'components/main.styled'
import { useTranslation } from 'react-i18next'


const dateInputStyle = {
  width: "100%",
  input: { color: '#273237', fontSize: '13px', fontWeight: 650 },
  "& .MuiInputLabel-root.Mui-focused": { 
    color: "var(--themeColor)"
  },
  "& .MuiOutlinedInput-root": {
   "& fieldset": { borderColor: 'rgba(59, 74, 79, .12)' },
   "&:hover > fieldset": { borderColor: "rgba(0, 180, 204, .28)" },
   "&.Mui-focused > fieldset": { borderColor: 'var(--themeColor)', borderWidth: '1px' },
   height: "48px",
   borderRadius: "11px",
   backgroundColor: '#f1f4f5',
  }
}

const FALLBACK_TIME_ZONES = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Australia/Sydney',
]

const pickerSlotProps = (label, onClick) => ({
  textField: {
    onClick,
    inputProps: { 'aria-label': label },
  },
  popper: {
    disablePortal: false,
    sx: {
      zIndex: 2200,
      '& .MuiPaper-root': {
        borderRadius: '16px',
        boxShadow: '0 22px 60px rgba(18, 35, 40, .22)',
      },
    },
  },
  dialog: { sx: { zIndex: 2200 } },
  mobilePaper: { sx: { borderRadius: '16px' } },
})

export default function CreateEventModal(props) {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch()
 
  const { user } = useSelector((state) => state.auth)
  const { profileChurch } = useSelector((state) => state.profileChurch)
  const eventChurchId = profileChurch?._id || (user?.isOrganization ? user._id : null)
  const { location, getCoordinatesLoading, getCoordinatesSuccess, getCoordinatesMessage, locationCoordinates, searchTerm } = useSelector((state) => state.maps)
  const { isEventLoading, isEventCreatedLoading, isEventCreatedSuccess, eventImagePreview, preselectedDate } = useSelector((state) => state.events)
  const [width, height] = useGetWindowSize()
  const [openStart, setOpenStart] = useState(false)
  const [openEnd, setOpenEnd] = useState(false)
  const [openEndTime, setOpenEndTime] = useState(false)
  const [openStartTime, setOpenStartTime] = useState(false) 
  const [addStartTime, setAddStartTime] = useState(false)
  const [addEndTime, setAddEndTime] = useState(false) 
  const [startDate, setStartDate] = useState(dayjs().startOf('day'));
  const [endDate, setEndDate] = useState(dayjs().add(1, 'day').startOf('day'));
  const [startTime, setStartTime] = useState( dayjs( `2024-01-17T15:30`));
  const [endTime, setEndTime] = useState( dayjs('2024-01-17T15:30') ); 
  const [addLocation, setAddLocatiion] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('') 
  const [eventId, setEventId] = useState('') //used when editing
  const [eventDataEdited, setEventDateEdited] = useState(false)
  const [eventlistIndex, setEventlistIndex] = useState() //used when editing
  const [isImageChanged, setIsImageChanged] = useState(false) //used when editing
  const [imageToShow, setImageToShow] = useState()
  const [hasEndDate, setHasEndDate ] = useState(false)
  const [discussionEnabled, setDiscussionEnabled] = useState(true) 
  const locationRef = useRef(null)
  const locationRequestRef = useRef(null)
  const [locationInput, setLocationInput] = useState('')
  const [inputFocus, setInputFocus] = useState('')
  const [allowRsvp, setAllowRsvp] = useState(false)
  const [isPublic, setIsPublic] = useState(false)
  const [eventFormat, setEventFormat] = useState('physical')
  const [onlineUrl, setOnlineUrl] = useState('')
  const [timeZone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)
  const availableTimeZones = (() => {
    const supported = typeof Intl.supportedValuesOf === 'function'
      ? Intl.supportedValuesOf('timeZone')
      : FALLBACK_TIME_ZONES
    return Array.from(new Set(['UTC', timeZone, ...supported].filter(Boolean)))
  })()
  const [confirmedLocation, setConfirmedLocation] = useState(null)

  const [{alt, src, edited, fileSrc}, setImg] = useState({
    src: placeholder,
    alt: 'Upload an Image',
    edited: false,
  });

  useEffect(() => {
    if(preselectedDate){
      setStartDate(dayjs(preselectedDate))
    }
  }, [preselectedDate])
 
  useEffect(() => {
    if(props.isEditing){
      try{  setImageToShow(`${props.data.image.url}`) }
      catch(e){ setImageToShow(`${imgUrl}/events/default/eventDefault.jpg}`) }

      // setStartDate(props.data.eventDate)
      setDescription(props.data.description)
      setName(props.data.eventName)
      setEventId(props.data._id)
      setEventlistIndex(props.index)
      setDiscussionEnabled(props.data.discussionEnabled)
      setIsPublic(props.data.privacy === 'public')
      setLocationInput(props.data.locationAddress)
      setEventFormat(props.data.eventFormat === 'online' ? 'online' : 'physical')
      setOnlineUrl(props.data.onlineUrl || '')
      setStartDate(dayjs(calendarDate(props.data.startDate)))
      setTimeZone(props.data.timeZone || 'UTC')
      setConfirmedLocation(props.data.coordinates ? { label: props.data.locationAddress, ...props.data.coordinates } : null)
      setAllowRsvp(props.data.allowRsvp)

      if(props.data.startTime){
        setStartTime(dayjs(`2024-01-17T${props.data.startTime}`))
        setAddStartTime(true)
      }

      if(props.data.endDate){ 
        setEndDate(dayjs(calendarDate(props.data.endDate)))
        setHasEndDate(true)

      }
      if(props.data.endTime){ 
        setEndTime(dayjs(`2024-01-17T${props.data.endTime}`)) 
        setAddEndTime(true)
      }

      setAddLocatiion(true)

      if (props.data.eventFormat !== 'online' && props.data.coordinates) {
        dispatch(setLocationCoordinates([props.data.coordinates.lat, props.data.coordinates.lng]))
      }
    }
  }, [])

  const handleDate = (date) => {
    if(props.isEditing){
      //because I am not setting the event date from the DB as a variable when user is editing
      //user will have to reset the eventDate so if they are editing and they didn;t reset the event date, they will get a toast notification
      //ideally we want to be able to keep the date from the DB when user is editing since they might not
      //need to edit the date. for now just warn user to readjust the desired date.
      setEventDateEdited(true)
      setStartDate(date)
    }else{
      // setStartDate(date)
      
      // using the data parameter to set the date
      setStartDate(date)
      console.log(date)
      console.log(startDate)

    }
  }

  const handleDescription = (e) => { 
    if(e.target.value.length < 1650){ 

      // setDescription(e.target.value.replace(/\n/g, '<br />'))

      setDescription(e.target.value)
    } 
  }

  const handleEventName = (e) => {
    if(e.target.value.length < 80){ 
      setName(e.target.value)
    } 

  }
  const handleImg = (e) => { 
    if(props.isEditing){
      setIsImageChanged(true)
      let fileName = e.target.files[0].name
      let fileType =  fileName.slice(fileName.lastIndexOf('.')+1).toLowerCase()
      if(fileType !== 'jpeg' && fileType !== 'jpg' && fileType !== 'png'){ return toast.error(translate('events:validation.imageType')) }
      setImg({
        src: URL.createObjectURL(e.target.files[0]),
        alt: e.target.files[0].name,
        fileSrc: e.target.files[0],
        edited: true
      }); 

    }else{
      let fileName = e.target.files[0].name
      let fileType =  fileName.slice(fileName.lastIndexOf('.')+1).toLowerCase()
      if(fileType !== 'jpeg' && fileType !== 'jpg' && fileType !== 'png'){ return toast.error(translate('events:validation.imageType')) }

      setImg({
        src: URL.createObjectURL(e.target.files[0]),
        alt: e.target.files[0].name,
        fileSrc: e.target.files[0],
        edited: true
      }); 
    }
  }

  const removeImage = () => {
    dispatch(removeEventImage())
    setImg({
        src: placeholder,
        fileSrc: '',
        alt: 'Upload an Image',
        edited: false
    });    
  }

  const handleSubmit = () => { 
    if(!eventChurchId){ return toast.error(translate('events:validation.church')) }
    
    if(!name.trim()) return toast.error(translate('events:validation.name'))
    if(!description.trim()) return toast.error(translate('events:validation.description'))
    if(!props.isEditing && !fileSrc) return toast.error(translate('events:validation.photo'))
    let normalized
    try {
      normalized = normalizeEvent({
        startDate: startDate?.isValid() ? startDate.format('YYYY-MM-DD') : '',
        endDate: hasEndDate && endDate?.isValid() ? endDate.format('YYYY-MM-DD') : '',
        startTime: addStartTime && startTime?.isValid() ? startTime.format('HH:mm') : '',
        endTime: hasEndDate && addEndTime && endTime?.isValid() ? endTime.format('HH:mm') : '',
        timeZone, eventFormat, onlineUrl,
        locationAddress: locationInput,
        coordinates: confirmedLocation?.label === locationInput ? confirmedLocation : null,
      })
    } catch (error) {
      return toast.error(error.message)
    }
    const formData = new FormData()
    const { coordinates, ...fields } = normalized
    Object.entries(fields).forEach(([key, value]) => formData.append(key, value ?? ''))
    if (eventFormat === 'physical') {
      formData.append('coordinatesLat', String(coordinates.lat))
      formData.append('coordinatesLng', String(coordinates.lng))
    }
    formData.append('churchId', eventChurchId)
    formData.append('eventName', name.trim())
    formData.append('description', description.trim())
    formData.append('privacy', isPublic ? 'public' : 'members')
    formData.append('discussionEnabled', String(discussionEnabled))
    formData.append('allowRsvp', String(allowRsvp))
    if (props.isEditing) {
      formData.append('eventId', eventId)
      formData.append('index', eventlistIndex)
      if (isImageChanged) formData.append('file', fileSrc)
      dispatch(updateEvent(formData))
    } else {
      formData.append('file', fileSrc)
      dispatch(createEvent(formData))
    }
  }

  useEffect(() => {
      if(isEventCreatedSuccess){
        toast.success(translate('events:create.success'))
        setName('')
        setDescription('')
        dispatch(removeEventImage())
        dispatch(hideEventModal())
      }
  }, [isEventCreatedSuccess, dispatch])


  const handleGetCoordinates = () => {
    if(!locationInput){
      toast.error(translate('events:validation.locationRequired'))
      return
    }
    locationRequestRef.current = locationInput
    dispatch(getCoordinates({address: locationInput}))
  }

  const handleLocation = (e) => {
    locationRequestRef.current = null
    setLocationInput(e.target.value)
    setConfirmedLocation(null)
    dispatch(resetMap())
  }

  useEffect(() => {
    
    if(locationRequestRef.current && searchTerm === locationRequestRef.current && getCoordinatesSuccess && location.data?.status === 'OK' && location.bestMatch){
        const point = location.data.results[0]?.geometry?.location
        if (point) {
          setLocationInput(location.bestMatch)
          setConfirmedLocation({ label: location.bestMatch, lat: point.lat, lng: point.lng })
        }
    }
  }, [getCoordinatesSuccess, location, searchTerm])


  return ( 
    <EventModalBackdrop role='presentation'>
      <EventModalWrap>
        <ModalCloseButton handler={() => dispatch(hideEventModal())} top="15px" right="15px" size='35px' />        
        <CreateEventFormTop>
            <EventNoteIcon style={{  fontSize: '30px', marginRight: '10px'}} />  
            <EventModalHeading> 
              {
                props.isEditing ? 
                (
                  translate("web:general.updateEvent")
                )
                :
                (
                  translate("web:general.createEvent")
                )
              } 
            </EventModalHeading>
        </CreateEventFormTop> 
        <ScrollContainer> 
        <ModalForm>
          <FormFieldCard>
            <FieldLabel><TitleRoundedIcon /><span>{translate('events:create.eventName')}</span></FieldLabel>
            <ModernInput value={name} onChange={handleEventName} maxLength='120' placeholder={translate("web:general.eventName")} />
          </FormFieldCard>

          <FormFieldCard role='group' aria-labelledby='event-dates-times-label'>
            <FieldLabel id='event-dates-times-label'><CalendarMonthRoundedIcon /><span>{translate('events:create.dateTime')}</span></FieldLabel>
            <AddInputDate role='group' aria-label={translate('events:create.eventDates')}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateWrap>
                  <DWH>{translate('events:create.startDate')}</DWH>
                {
                  width > 768 ?
                  ( 
                    <DesktopDatePicker
                      value={startDate}
                      onChange={handleDate}
                      sx={dateInputStyle}
                      open={openStart}
                      onClose={() => setOpenStart(false)}
                      slotProps={pickerSlotProps('Start date', () => setOpenStart(true))}
                      /> 
                  )
                  :
                  ( 
                    <MobileDatePicker value={startDate} onChange={handleDate} sx={dateInputStyle} slotProps={pickerSlotProps('Start date')} />
                  )
                }                 
                </DateWrap>
              {
                hasEndDate ?
                (
                  <DateWrap>
                    <DWH>{translate('events:create.endDate')}</DWH>

                    {
                      width > 768 ?
                        (
                          <DesktopDatePicker
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            sx={dateInputStyle}
                            open={openEnd}
                            onClose={() => setOpenEnd(false)}
                            slotProps={pickerSlotProps('End date', () => setOpenEnd(true))}
                            /> 
                        )
                        :
                        (
                          <MobileDatePicker value={endDate} onChange={(newValue) => setEndDate(newValue)} sx={dateInputStyle} slotProps={pickerSlotProps('End date')} />
                        )
                      }
                    </DateWrap>
                )
                :
                (
                  <Ending type='button' onClick={() => setHasEndDate(true)}> <DateRangeIcon /> {translate("web:general.endDate")}  </Ending>
                )
              } 
              </LocalizationProvider>
            </AddInputDate>
            <AddInputDate role='group' aria-label={translate('events:create.eventTimes')}>
              {
                addStartTime ? 
                (
                  <DateWrap>
                    <DWH>{translate('events:create.startTime')}</DWH>
                    <LocalizationProvider dateAdapter={AdapterDayjs}> 
                      <DesktopTimePicker
                        value={startTime}
                        onChange={(newValue) => setStartTime(newValue)}
                        sx={dateInputStyle}
                        defaultValue={dayjs('2022-04-17T15:30')} 
                        open={openStartTime}
                        onClose={() => setOpenStartTime(false)}
                        slotProps={pickerSlotProps('Start time', () => setOpenStartTime(true))}
                        />
                    </LocalizationProvider>         
                  </DateWrap>
                )
                :
                (
                  <DateWrap><Ending type='button' onClick={() => setAddStartTime(true)}><MoreTimeIcon size={15} /> {translate('events:create.addStartTime')}</Ending></DateWrap>
                )
              }  
              {
                hasEndDate && ( 
                  !addEndTime ? 
                  (
                    <DateWrap><Ending type='button' onClick={() => setAddEndTime(true)}><MoreTimeIcon size={15} /> {translate('events:create.addEndTime')}</Ending></DateWrap>
                  )
                  :
                  (
                    <DateWrap>
                    <DWH>{translate('events:create.endTime')}</DWH>
                      <LocalizationProvider dateAdapter={AdapterDayjs}> 
                        <DesktopTimePicker
                          value={endTime}
                          onChange={(newValue) => setEndTime(newValue)}
                          sx={dateInputStyle}
                          defaultValue={dayjs('2022-04-17T15:30')} 
                          open={openEndTime}
                          onClose={() => setOpenEndTime(false)}
                          slotProps={pickerSlotProps('End time', () => setOpenEndTime(true))}
                          />
                      </LocalizationProvider>                    
                    </DateWrap>
                  ) 
                )
              } 
            </AddInputDate>
          </FormFieldCard>

          <FormFieldCard>
            <FieldLabel><NotesRoundedIcon /><span>Description</span></FieldLabel>
            <ModernTextarea
              value={description}
              onChange={handleDescription}
              placeholder={translate("web:general.eventDescription")}
            />
          </FormFieldCard>
            <TimeZoneField>
              <FieldLabel><ScheduleRoundedIcon /><span>{translate('events:create.timeZone')}</span></FieldLabel>
              <FilterSelectWrap $enabled>
                <select id='event-time-zone' aria-label={translate('events:create.timeZone')} value={timeZone} onChange={(event) => setTimeZone(event.target.value)}>
                  {availableTimeZones.map((zone) => <option key={zone} value={zone}>{zone.replaceAll('_', ' ')}</option>)}
                </select>
                <ExpandMoreRoundedIcon />
              </FilterSelectWrap>
            </TimeZoneField>
            <SettingsSection>
              <OptionsHeader>
                <OptionsHeaderIcon><TuneRoundedIcon /></OptionsHeaderIcon>
                <div>
                  <h3>{translate('events:create.settings')}</h3>
                  <p>{translate('events:create.settingsHelp')}</p>
                </div>
              </OptionsHeader>
              <MoreOptionsContainer>
                <DropdownField>
                  <FieldLabel><PlaceOutlinedIcon /><span>{translate('events:create.format')}</span></FieldLabel>
                  <FilterSelectWrap $enabled>
                    <select aria-label={translate('events:create.format')} value={eventFormat} onChange={(event) => setEventFormat(event.target.value)}>
                      <option value='physical'>{translate('events:create.physical')}</option>
                      <option value='online'>{translate('events:create.online')}</option>
                    </select>
                    <ExpandMoreRoundedIcon />
                  </FilterSelectWrap>
                </DropdownField>

                <DropdownField>
                  <FieldLabel><ChatBubbleOutlineRoundedIcon /><span>Discussion</span></FieldLabel>
                  <FilterSelectWrap $enabled={discussionEnabled}>
                    <select
                      aria-label='Discussion'
                      value={discussionEnabled ? 'on' : 'off'}
                      onChange={(event) => {
                        const enabled = event.target.value === 'on'
                        setDiscussionEnabled(enabled)
                        toast(translate(enabled ? 'events:create.commentsEnabled' : 'events:create.commentsDisabled'))
                      }}
                    >
                      <option value='on'>{translate('events:create.on')}</option>
                      <option value='off'>{translate('events:create.off')}</option>
                    </select>
                    <ExpandMoreRoundedIcon />
                  </FilterSelectWrap>
                </DropdownField>

                <DropdownField>
                  <FieldLabel><HowToRegOutlinedIcon /><span>RSVP</span></FieldLabel>
                  <FilterSelectWrap $enabled={allowRsvp}>
                    <select
                      aria-label='RSVP'
                      value={allowRsvp ? 'on' : 'off'}
                      onChange={(event) => {
                        const enabled = event.target.value === 'on'
                        setAllowRsvp(enabled)
                        toast(translate(enabled ? 'events:create.rsvpEnabled' : 'events:create.rsvpDisabled'))
                      }}
                    >
                      <option value='on'>{translate('events:create.on')}</option>
                      <option value='off'>{translate('events:create.off')}</option>
                    </select>
                    <ExpandMoreRoundedIcon />
                  </FilterSelectWrap>
                </DropdownField>

                <DropdownField>
                  <FieldLabel><VisibilityOutlinedIcon /><span>Visibility</span></FieldLabel>
                  <FilterSelectWrap $enabled={isPublic}>
                    <select
                      aria-label='Visibility'
                      value={isPublic ? 'public' : 'members'}
                      onChange={(event) => {
                        const makePublic = event.target.value === 'public'
                        setIsPublic(makePublic)
                        toast(translate(makePublic ? 'events:create.publicNotice' : 'events:create.membersNotice'))
                      }}
                    >
                      <option value='public'>{translate('events:create.public')}</option>
                      <option value='members'>{translate('events:create.membersOnly')}</option>
                    </select>
                    <ExpandMoreRoundedIcon />
                  </FilterSelectWrap>
                </DropdownField>
              </MoreOptionsContainer>
            </SettingsSection>
            {eventFormat === 'physical' ? (
              <FormFieldCard>
                <FieldLabel><PlaceOutlinedIcon /><span>{translate('events:create.location')}</span></FieldLabel>
                <LocationInputWrap>
                  <ListingInput
                    onFocus={() => setInputFocus('location')}
                    ref={locationRef} type='text'
                    value={locationInput}
                    onChange={handleLocation}
                    placeholder={`${translate("web:general.eventLocation")} ${inputFocus === 'location' ? '(city, ZIP code, or full address)' : ''}`}
                  />
                  {searchTerm === locationInput || locationInput === location.bestMatch ? (
                    <InputBtn onClick={() => { setLocationInput(''); dispatch(resetMap()) }}>
                      {translate("web:general.clear")}
                    </InputBtn>
                  ) : (
                    <InputBtn onClick={handleGetCoordinates}>{translate("web:general.setLocation")}</InputBtn>
                  )}
                </LocationInputWrap>
              </FormFieldCard>
            ) : (
              <FormFieldCard>
                <FieldLabel><LinkRoundedIcon /><span>{translate('events:create.onlineLink')}</span></FieldLabel>
                <ModernInput
                  type='url'
                  value={onlineUrl}
                  onChange={(event) => setOnlineUrl(event.target.value)}
                  placeholder={translate('events:create.onlineUrl')}
                />
              </FormFieldCard>
            )}
          <MiddleSection>
          { edited ? 
                  (
                    <ImagePlaceholder>  <ImgPreview src={src} alt={alt} /> </ImagePlaceholder >
                  ) : props.isEditing && (
                    <ImagePlaceholder><ImgPreview src={imageToShow} alt={translate('events:create.addPhoto')} /></ImagePlaceholder>
                  )
                } 
            <MiddleButtonsWrap> 
              <AddImage>  
                <AddImageBtnsWrap>
                  <CEMLabel>  
                    <AddPhotoAlternateIcon />
                    <span style={{marginLeft: '10px'}}> 
                    { edited ? 
                      (translate("web:general.replace"))
                      :
                      (translate("web:general.add"))}
                      {' ' + translate("web:general.image")}
                      </span> 
                  </CEMLabel>
                  <input hidden id="imageUpload" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={handleImg}/>
                  { edited && ( 
                    <RemoveImage onClick={removeImage}> {translate("web:general.remove")} </RemoveImage>
                  )}
                </AddImageBtnsWrap>
              </AddImage> 
            </MiddleButtonsWrap> 
          </MiddleSection>

          <ButttonWrap style={{ marginTop: '40px', marginBottom: '0px' }} >
            {props.isEditing ? 
              (
                <SubmitButton disabled={isEventCreatedLoading} onClick={handleSubmit}>
                {isEventCreatedLoading ? translate('events:create.updating') : translate('events:create.update')}
                </SubmitButton> 
              )
              :
              (
                <SubmitButton 
                  disabled={isEventCreatedLoading} 
                  onClick={handleSubmit}>
                  { isEventCreatedLoading ? 
                    ( 
                      <SpinnerSmall /> 
                    )
                    :
                    (
                      translate("web:general.createEvent")
                    )}
                </SubmitButton> 
              )
            }            
          </ButttonWrap> 
        </ModalForm>
      </ScrollContainer>
      </EventModalWrap>
    </EventModalBackdrop>
  )
}

const InputBtn = styled(pBtnSmall)`
    flex: 0 0 auto;
    min-width: 112px;
    height: 44px;
    padding: 0 16px;
    border-radius: 11px;
    background: var(--themeColor);
    color: white;
    font-weight: 700;
    box-shadow: 0 5px 14px rgba(0, 180, 204, .18);

    &:hover { filter: brightness(.95); }
    @media (max-width: 620px) { width: 100%; }
`

const MoreOptionsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  height: fit-content;

  @media (max-width: 1050px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 620px) { grid-template-columns: 1fr; }
`

const DropdownField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  padding: 13px;
  border: 1px solid rgba(45, 61, 66, .09);
  border-radius: 14px;
  background: rgba(255, 255, 255, .82);
  box-shadow: 0 1px 2px rgba(20, 35, 40, .04);
  transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;

  &:hover {
    border-color: rgba(0, 180, 204, .3);
    box-shadow: 0 8px 22px rgba(26, 43, 48, .07);
    transform: translateY(-1px);
  }
`

const FormFieldCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  width: 100%;
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid rgba(45, 61, 66, .09);
  border-radius: 14px;
  background: #f8fafb;
  box-shadow: 0 1px 2px rgba(20, 35, 40, .04);
  transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;

  &:hover {
    border-color: rgba(0, 180, 204, .3);
    box-shadow: 0 8px 22px rgba(26, 43, 48, .07);
    transform: translateY(-1px);
  }
`

const ModernInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid rgba(59, 74, 79, .12);
  border-radius: 11px;
  outline: none;
  background: #f1f4f5;
  color: #273237;
  font-size: 13px;
  font-weight: 650;
  transition: background .18s ease, border-color .18s ease, box-shadow .18s ease;

  &::placeholder { color: #889397; font-weight: 500; }
  &:hover { background: #e9edef; border-color: rgba(0, 180, 204, .28); }
  &:focus { background: white; border-color: var(--themeColor); box-shadow: 0 0 0 4px rgba(0, 180, 204, .12); }
`

const ModernTextarea = styled.textarea`
  width: 100%;
  min-height: 118px;
  padding: 13px 14px !important;
  resize: vertical !important;
  border: 1px solid rgba(59, 74, 79, .12) !important;
  border-radius: 11px !important;
  outline: none;
  background: #f1f4f5 !important;
  color: #273237;
  font-family: inherit !important;
  font-size: 13px !important;
  line-height: 1.5;
  transition: background .18s ease, border-color .18s ease, box-shadow .18s ease;

  &::placeholder { color: #889397; font-size: 13px !important; }
  &:hover { background: #e9edef !important; border-color: rgba(0, 180, 204, .28) !important; }
  &:focus { background: white !important; border-color: var(--themeColor) !important; box-shadow: 0 0 0 4px rgba(0, 180, 204, .12); }
`

const TimeZoneField = styled(DropdownField)`
  width: 100%;
  margin: 4px 0 12px;
  background: #f8fafb;
`

const FieldLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #364247;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: .01em;

  svg { width: 18px; height: 18px; color: var(--themeColor); }
`

const FilterSelectWrap = styled.div`
  position: relative;
  min-width: 0;

  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 13px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $enabled }) => $enabled ? 'var(--themeColor)' : '#9aa4a8'};
    box-shadow: ${({ $enabled }) => $enabled ? '0 0 0 4px rgba(0, 180, 204, .11)' : 'none'};
    transform: translateY(-50%);
    pointer-events: none;
  }

  select {
    width: 100%;
    height: 44px;
    appearance: none;
    padding: 0 40px 0 32px;
    border: 1px solid rgba(59, 74, 79, .12);
    border-radius: 11px;
    outline: none;
    background: #f1f4f5;
    color: #273237;
    cursor: pointer;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    transition: background .18s ease, border-color .18s ease, box-shadow .18s ease;
  }

  select:hover { background: #e9edef; border-color: rgba(0, 180, 204, .28); }
  select:focus-visible { border-color: var(--themeColor); box-shadow: 0 0 0 4px rgba(0, 180, 204, .12); }
  > svg { position: absolute; top: 50%; right: 10px; transform: translateY(-50%); pointer-events: none; color: #59666a; }
`

const OptionsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 15px;

  h3 { margin: 0; color: #263338; font-size: 15px; font-weight: 750; }
  p { margin: 3px 0 0; color: #788286; font-size: 11px; line-height: 1.4; }
`

const OptionsHeaderIcon = styled.span`
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  background: rgba(0, 180, 204, .11);
  color: var(--themeColor);
  svg { font-size: 20px; }
`

const MiddleButtonsWrap = styled.div`

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

`

const DateWrap = styled.div`
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 6px;
`

const DWH = styled.div`
  font-size: 11px;
  color: #697579;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & svg{
    font-size: 20px;
    margin-right: 10px;
  }

`
 

const ScrollContainer = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;

  /* remove scrollbar */
  ::-webkit-scrollbar {
      display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

`


const EventModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  background: rgba(14, 22, 26, 0.48);
  backdrop-filter: blur(1px);

  @media (max-width: 768px) { padding: 8px; }
`

const EventModalWrap = styled.div`
  z-index: 1;
  width: 1225px; 
  max-width: 92vw;
  height: fit-content;
  max-height: 90vh;
  overflow: hidden;

  /* hide scroll bar */
  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  

  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 12px;
  position: relative;
  animation: animate 0.3s; 
  padding: 20px;
  transition: all 0.3s ease-in-out; 
  box-shadow: 0 24px 70px rgba(0, 0, 0, .28);

  @media (max-width: 768px) {
    top: 0;
    width: 98%; 
    max-width: 98%;
    min-height: 50vh; 
    height: fit-content ;
    max-height: 70vh;
    padding: 10px;
  }
`

const EventModalHeading = styled.div`
  font-size: 14px;
  font-weight: 100; 

  @media (max-width: 768px) {
    font-size: 14px;
    padding-top: 0px;

  }
`
const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  margin-top: 10px;
  width: 100%; 
  textarea{
    resize: none;
    padding: 10px; 
    border: none;
    outline: none;
    border-radius: 5px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 17px;
  }
  textarea:focus{
    outline: none;
  }
  textarea::placeholder{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 17px;
  }
    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        font-size: 13px;
        padding: 5px 9px;
    }

`

const MiddleSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
 
const CEMLabel = styled.label.attrs(() => ({
  htmlFor: 'imageUpload'
}))`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  padding: 0px 20px;
  margin-left: 0px;
  width: fit-content;
  color: var(--lightThemeFontColor); 
  background-color: #e7e7e7;
  cursor: pointer;
  font-size: 11px;
  border-radius: 40px;
 
`

const AddImageBtnsWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    color: #535353;
    margin-top: 10px;
`
const RemoveImage = styled.div`
    padding-left: 5px;
    cursor: pointer;
    font-size: 11px;
    color: rgb(80,80,80);
    &:hover{
      text-decoration: underline;
    }
`

const ImagePlaceholder = styled.div`
    width: 100%;
    padding: 5px;
    height: fit-content; 
    margin-bottom: 10px;
    border-radius: 4px;

    & img{
      border-radius: 6px;
      box-shadow: 0px 0px 5px #a6a6a6;
    }

`
const AddImage = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
        width: 100%;
    }
`


const ImgPreview = styled.img`
    width: 100%;
    height: auto;
`

const AddInputDate = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: end;
    justify-items: stretch;
    gap: 12px;
    font-size: 11px;
    width: 100%;
    margin-bottom: 12px;
    height: fit-content;

    > :only-child {
      grid-column: 1 / -1;
      width: min(100%, 420px);
      justify-self: center;
    }

    & input{
        display: flex;
        padding: 5px;
        border: none;
        width: 100%
    };
    & input:focus{
        outline: none;
    }
    @media (max-width: 768px) {
        padding: 0;
        grid-template-columns: 1fr;

        > :only-child { grid-column: auto; width: 100%; }
    }
`
const Ending = styled(pBtn)` 
  width: 100%;
  min-height: 44px;
  padding: 0 14px;
  border-radius: 11px;
  background: #eef2f3;
  color: #536064;
  font-size: 12px;
  font-weight: 700;
  outline: none;

  &:focus-visible { box-shadow: 0 0 0 4px rgba(0, 180, 204, .16); }
  &:hover{
      background-color: #e3e8ea;
    }
`
const CreateEventFormTop = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--lightThemeFontColor); 
    justify-content: flex-start;    
    margin-bottom: 20px;
`

const LocationInputWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    @media (max-width: 620px) { flex-direction: column; align-items: stretch; }
`

const ListingInput = styled(ModernInput)`flex: 1; min-width: 0;`

const SettingsSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 28px;
    padding: 18px;
    border: 1px solid rgba(45, 61, 66, .08);
    border-radius: 18px;
    background: linear-gradient(145deg, #f8fafb 0%, #f1f6f7 100%);

    @media (max-width: 768px) { padding: 14px; border-radius: 14px; }
`
 
